var map = {
	"./africa/sport.layout.vue": [
		"ZGO0",
		8
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "xovX";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./skins/xkiosk/layouts/sport lazy ^\.\/.*\/sport\.layout\.vue$
// module id = xovX
// module chunks = 37